module.exports = __webpack_public_path__ + "img/norecommend.f23bf352.png";